/**
 * If DOM is available in the current environment.
 *
 * @type {boolean}
 */
const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export default canUseDOM;
